// extracted by mini-css-extract-plugin
export default {"ground-truth__toggle":"lsf-ground-truth__toggle","ground-truth__indicator":"lsf-ground-truth__indicator","ground-truth__indicator_active":"lsf-ground-truth__indicator_active"};
    if(module.hot) {
      // 1732531521183
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  